import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import SalesUserService from '../../services/SalesUserService';
import * as SalesUserActions from './sales-user.actions';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class SalesUserEffects {
    loadSalesUsers$;
    loadSalesUserMe$;
    loadSalesUser$;
    changeSalesUserCoins$;
    addCoinsToCustomer$;

    constructor(
        private actions$: Actions,
        private salesUserService: SalesUserService
    ) {
        this.loadSalesUsers$ = createEffect(() =>
            this.actions$.pipe(
                ofType(SalesUserActions.loadSalesUsers),
                mergeMap(() =>
                    this.salesUserService.getSalesUsers().pipe(
                        map((salesUsers: any) => SalesUserActions.loadSalesUsersSuccess({ salesUsers: salesUsers as any })),
                        catchError(error => of(SalesUserActions.loadSalesUsersFailure({ error })))
                    )
                )
            )
        );

        this.loadSalesUserMe$ = createEffect(() =>
            this.actions$.pipe(
                ofType(SalesUserActions.loadSalesUserMe),
                mergeMap(() =>
                    this.salesUserService.getMe().pipe(
                        map((salesUser: any) => SalesUserActions.loadSalesUserMeSuccess({ salesUser: salesUser as any })),
                        catchError(error => of(SalesUserActions.loadSalesUserMeFailure({ error })))
                    )
                )
            )
        );

        this.loadSalesUser$ = createEffect(() =>
            this.actions$.pipe(
                ofType(SalesUserActions.loadSalesUser),
                mergeMap(({ azureObjectId }) =>
                    this.salesUserService.getSalesUser(azureObjectId).pipe(
                        map((salesUser: any) => SalesUserActions.loadSalesUserSuccess({ salesUser: salesUser as any })),
                        catchError(error => of(SalesUserActions.loadSalesUserFailure({ error })))
                    )
                )
            )
        );

        this.changeSalesUserCoins$ = createEffect(() =>
            this.actions$.pipe(
                ofType(SalesUserActions.changeSalesUserCoins),
                mergeMap(({ id, model }) =>
                    this.salesUserService.changeCoins(id, model).pipe(
                        map((salesUser: any) => SalesUserActions.changeSalesUserCoinsSuccess({ salesUser: salesUser as any })),
                        catchError(error => of(SalesUserActions.changeSalesUserCoinsFailure({ error })))
                    )
                )
            )
        );

        this.addCoinsToCustomer$ = createEffect(() =>
            this.actions$.pipe(
                ofType(SalesUserActions.addCoinsToCustomer),
                mergeMap(({ customerNo, model }) =>
                    this.salesUserService.addCoinsToCustomer(customerNo, model).pipe(
                        map((response: any) => SalesUserActions.addCoinsToCustomerSuccess({ customer: response.customer, salesUser: response.salesUser })),
                        catchError(error => of(SalesUserActions.addCoinsToCustomerFailure({ error })))
                    )
                )
            )
        );
    }
}
